import React, { useMemo } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import usePreferencesController from '~/hooks/use_preferences_controller'
import PreferenceCard from './preferences_screen/components/preference_card'
import { preferenceRoutes } from './preferences_screen/preferences_config'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { isMainUser } from '@verzekeringapp-mono/shared/src/utils/resource_utils'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'

const PreferencesScreen: React.FC = () => {
  const { openPreference, relationToggles, statuses } = usePreferencesController()
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const mainUser = useMemo(() => isMainUser(resourceAuthorization?.roles), [resourceAuthorization?.roles])

  return (
    <ScreenWrapper>
      <div className='flex flex-col gap-4 md:w-2/6 w-full'>
        {
          mainUser && relationToggles && (
            <>
              <PreferenceCard
                title={preferenceRoutes['cooperation-membership'].cardTitle}
                description={preferenceRoutes['cooperation-membership'].cardDescription}
                statusLabel={statuses.cooperationMembership.label}
                statusTone={statuses.cooperationMembership.tone}
                onPress={() => {
                  openPreference('cooperation-membership')
                }}
              />

              <PreferenceCard
                title={preferenceRoutes['zest-magazine'].cardTitle}
                description={preferenceRoutes['zest-magazine'].cardDescription}
                statusLabel={statuses.zestMagazine.label}
                statusTone={statuses.zestMagazine.tone}
                blocked={!relationToggles.cooperationMembership}
                onPress={() => {
                  openPreference('zest-magazine')
                }}
              />

              <PreferenceCard
                title={preferenceRoutes['customer-panel'].cardTitle}
                description={preferenceRoutes['customer-panel'].cardDescription}
                statusLabel={statuses.customerPanel.label}
                statusTone={statuses.customerPanel.tone}
                onPress={() => {
                  openPreference('customer-panel')
                }}
              />
            </>
          )
        }

        <PreferenceCard
          title={preferenceRoutes.display.cardTitle}
          description={preferenceRoutes.display.cardDescription}
          statusLabel={statuses.display.label}
          statusTone={statuses.display.tone}
          onPress={() => {
            openPreference('display')
          }}
        />
      </div>
    </ScreenWrapper>
  )
}

export default PreferencesScreen
